import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { DeleteAntibiogram } from './DeleteAntibiogram';
import { FormAntibiogram } from './FormAntibiogram';

export const ModalAntibiogram = (props) => {

    const {
        modal, modalTitle, toggle, method, onChangeAntibiotics, antibioticsSelected,
        validaciones,
        antibiogram, antibiotics,
        handleInputChange, loading,
        saveCreate, saveUpdate, saveDelete
    } = props;

    return (
        <Modal isOpen={modal} toggle={toggle} backdrop='static' keyboard={false} centered={true} className='modal-lg'  >
            <ModalHeader toggle={toggle} className="bg-primary f-12">
                {modalTitle}
            </ModalHeader>
            {
                method === "create"
                    ? <FormAntibiogram
                        button={"Crear antibiograma"}
                        {...{ toggle, loading, handleInputChange, antibiotics, onChangeAntibiotics, antibioticsSelected, validaciones, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormAntibiogram
                            button={"Actualizar antibiograma"}
                            {...{ toggle, loading, handleInputChange, antibiotics, onChangeAntibiotics, antibioticsSelected, validaciones, methodAction: saveUpdate, antibiogram, }} />
                        :
                        <DeleteAntibiogram {...{ toggle, loading, antibiogram, saveDelete }} />
            }
        </Modal>
    )
}
